"use client";
import { forwardRef } from "react";
import { TextField, TextFieldProps } from "@mui/material";

const AppTextField = forwardRef(
  ({ sx, ...otherProps }: TextFieldProps, ref) => {
    return (
      <TextField
        sx={{
          ".MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "primary.main",
          },
          ".MuiOutlinedInput-notchedOutline": {
            border: "1px solid",
            borderColor: "border.main",
            borderRadius: "4px",
          },
          ".MuiInputBase-root.MuiOutlinedInput-root": {
            paddingLeft: 0,
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: "4px",
            backgroundColor: "common.white",
            color: "common.black",
          },
          "textarea.MuiInputBase-input.MuiOutlinedInput-input": {
            minHeight: "58px",
          },
          ".MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: "disabled.main",
            color: "text.disabled",
          },
          ".MuiButtonBase-root.MuiIconButton-root": {
            color: "common.black",
          },
          ".MuiButtonBase-root.MuiIconButton-root.Mui-disabled": {
            color: "text.disabled",
          },
          ".MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "border.main",
            },
          ".MuiInputBase-root.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "error.main",
            },
          ".MuiInputBase-input.MuiOutlinedInput-input": {
            "&.Mui-disabled": {
              WebkitTextFillColor: "unset",
            },
            borderRadius: "4px",
            fontSize: "14px",
            lineHeight: "18px",
            padding: "11px 8px",
            height: "unset",
            "@media (max-width: 991.98px)": {
              fontSize: "16px",
              lineHeight: "20px",
            },
          },
          "&& .MuiInputBase-inputSizeSmall": {
            paddingTop: "7px",
            paddingBottom: "7px",
          },
          ...sx,
        }}
        fullWidth
        inputRef={ref}
        {...otherProps}
      />
    );
  }
);
AppTextField.displayName = "AppTextField";
export default AppTextField;
